<template>
    <div class="supervision-comments-modal">
        <b-modal ref="modal" size="xl" ok-title="add comment" :title="this.title" scrollable @shown="scrollToBottom">

          <LongTextFormItem :item="{title: 'Description',value: this.actions,required:false,disabled:true}" />

          <div class="comments">
            <div class="comment-container" v-for="(comment, index) in comments">

<!--              <p>{{ comment.CommentDate }}</p>-->

              <p :class="{
                          'comment-card':true,
                          'comment-left-card' : comment.CommentBy === review_type,
                          'comment-right-card':comment.CommentBy !== review_type
                         }">
                {{ comment.Comment }}
              </p>

              <p :class="{
                          'comment-author':true,
                          'comment-author-left' : comment.CommentBy === review_type,
                          'comment-author-right':comment.CommentBy !== review_type
                         }"
              v-if="comments[index + 1] && comment.CommentBy !== comments[index + 1].CommentBy || index + 1 === comments.length">
                {{ comment.CommentBy }}
              </p>

            </div>
          </div>

          <template #modal-footer>

            <div style="width:100%;display:flex;gap:20px;">
              <FreeTextFormItem style="flex-grow:1;margin-bottom:0;" :item="comment" />
              <b-button class="mb-0 ovr-button__inverted actions-save" @click="addComment()" variant="dark">Add Comment</b-button>

            </div>


          </template>


        </b-modal>
    </div>
</template>

<script>
    import FreeTextFormItem from "@/components/form/FreeTextFormItem.vue";
    import LongTextFormItem from "@/components/form/LongTextFormItem.vue";

    export default {
      name: "supervisionTopicModal",
      props: ["supervisionId"],
      components:
      {
        LongTextFormItem,
        FreeTextFormItem
      },
        data() {
            return {
              loading: false,
              id:null,
              title:'',
              actions:'',
              comments:[],
              review_type:null,
              guest:null,
              comment:
              {
                title: "",
                value:  "",
                required:false,
                disabled:false,
                type:1
              },
            }
        },
        methods:
          {
            show(id,topic_title,topic_actions,topic_comments,review_type,guest)
            {
                this.topicId = id;
                this.title = topic_title;
                this.actions = topic_actions;
                this.comments = topic_comments ?? [];
                this.review_type = review_type;
                this.guest = guest;
                this.$refs.modal.show();
            },
            scrollToBottom()
            {
              let modal_body = document.querySelector('.modal-body');

              if (modal_body) {
                const start = modal_body.scrollTop;
                const end = modal_body.scrollHeight - modal_body.clientHeight;
                const distance = end - start;
                const step = distance / 30;  // Number of steps to take (controls the smoothness)
                let currentStep = 0;

                // Smooth scroll animation
                const interval = setInterval(() =>
                {
                  modal_body.scrollTop += step;
                  currentStep++;

                  // Stop when the scroll is at the bottom
                  if (currentStep >= 30)
                  {
                    clearInterval(interval);
                  }
                }, 10);  // The interval time (controls the speed of scroll)
              }
            },
            close()
            {
                this.$refs.modal.hide();
            },
            addComment()
            {
              if(this.comment.value.trim() === "") return;
              if(this.loading) return;
              
              this.loading = true;
              event.preventDefault();

              let author = 'Supervisee';

              if(this.guest)
              {
                author = this.review_type;
              }
              else if(this.review_type == 'Supervisor')
              {
                author = 'Supervisee';
              }
              else if(this.review_type == 'Supervisee')
              {
                author = 'Supervisor';
              }

              this.$api.v2.post('supervision/'+this.supervisionId+'/'+this.topicId+'/comment',
            {
                    comment:this.comment.value,
                    author:author,
                  },
          {
                    headers:
                    {
                      'Content-Type': 'application/json'
                    }
                  }
              ).then((resp) =>
              {
                this.$success('Comment Added', resp.body.message);
              }).catch((resp) =>
              {
                this.$httpError('Failed to add comment', resp);
              }).then(() =>
              {
                this.loading = false;
                const now = new Date();
                const formattedDateTime = now.toISOString().slice(0, 19).replace('T', ' ');

                this.comments.push({
                  Comment: this.comment.value,
                  CommentBy: author,
                  CommentDate: formattedDateTime,
                  SupervisionId:this.supervisionId,
                  TopicId: this.topicId
                });

                // Emit event to update parent component's state
                this.$emit('comment-added', {
                  topicId: this.topicId,
                  comments: this.comments
                });

                this.comment.value = "";

                setTimeout(() =>
                {
                  this.scrollToBottom();
                }, 50);

              });
            }
        }
    }
</script>

<style scoped>
.comments
{
  display:flex;
  flex-direction:column;
  gap:15px;
}

.comment-container
{
  width:100%;
  display:flex;
  flex-direction:column;
}

.comment-card
{
  width:54%;
  padding:15px;
  margin-bottom:0.2rem;
}

.comment-author { font-weight: 700;color:#385372; }
.comment-author-right { text-align:right; }


.comment-left-card,
.comment-left-card > *
{
  background:#3853720D;
  color:#385372;
}
.comment-right-card,
.comment-right-card > *
{
  background:#385372;
  color:white;
  align-self:end;
}

.modal-body {
  scroll-behavior: smooth;
}
</style>
